import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useAuthStore } from '@core/authStore';
import App from './App';
import { Login } from './pages/Login';
import { AuthCallback } from './pages/AuthCallback';
import { ProtectedRoute } from './components/ProtectedRoute';

/**
 * Home is the atlas map shell in both modes: a `?order=` link (public or
 * shared) shows the viewer with no login required; otherwise it is the empty
 * atlas, gated behind auth, where the TopBar project switcher drives
 * navigation (projects -> orders). One map view, not a separate grid page.
 */
function Home() {
  const hasOrder = !!new URLSearchParams(window.location.search).get('order');
  if (hasOrder) return <App />;
  return (
    <ProtectedRoute>
      <App />
    </ProtectedRoute>
  );
}

// Vite base is '/' on the prod subdomain and '/atlas/' in the dev compose.
// react-router wants a basename without a trailing slash ('' for root).
const BASENAME = (import.meta.env.BASE_URL || '/').replace(/\/$/, '');

/**
 * Atlas router shell.
 *
 * - /login, /auth/callback: the authenticated-client entry.
 * - everything else: the existing order viewer (App), which reads ?order=
 *   and stays publicly reachable for public/shared orders. The authenticated
 *   project shell will replace the no-order home in a later step.
 */
export default function Root() {
  const initialize = useAuthStore((s) => s.initialize);

  useEffect(() => {
    initialize();
  }, [initialize]);

  return (
    <BrowserRouter basename={BASENAME}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}
